export default function Archive07() {
  return (
    <div
      data-testid="archive-07-page"
      className="min-h-screen bg-[#0c0c0e] flex flex-col items-center justify-center pb-10"
      style={{ textTransform: "none" }}
    >
      <img
        src="/assets/archive-07.png"
        alt=""
        className="w-full h-auto"
        draggable={false}
      />
      <a
        href="/"
        data-testid="archive-07-return"
        className="mt-10 text-[11px] tracking-[0.25em] text-white/20 hover:text-white/40 transition-colors"
      >
        ← RUNRS
      </a>
    </div>
  );
}
